import React from 'react';
import login_logo from '../../../images/login-logo.svg';
import "./Pwsuccess.css";
import { useNavigate } from 'react-router-dom';
function PasswordsuccessComp() {
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        navigate('/login')
    };

    return (
        <section className='login-page-one code-verify-section'>
            <div className='container-fluid p-0'>
                <div className='row m-0 row-password pw-success'>
                    <div className='col-md-6'>
                        <div className='login-right-block logo-left-block mb-5'>
                            <div className='login-logoimg text-center forgotpw-block'>
                                <img src={login_logo} alt="login-logo" className="login_logo_img"></img>
                            </div>
                        </div>
                        <div className='banner-contents'>
                            <div className='banner-image'>
                                {/* <img src={banner_img} alt="banner-image"></img> */}
                                <div className='text-overlay'>
                                    <h5>Welcome Back!</h5>
                                    <p>Elevate your business insights with precision. Log in to discover and refine your Ideal Customer Profiles effortlessly.</p>

                                </div>
                            </div>


                        </div>
                    </div>
                    <div className='col-md-6 login-cols-block'>
                        <div className='login-right-block desktop-view'>
                            <div className='login-logoimg text-center forgotpw-block'>
                                <img src={login_logo} alt="login-logo" className="login_logo_img"></img>
                            </div>
                        </div>
                        <div className='login-box'>
                            <div className='login-information code-verify'>
                                <div className='code-verify-success text-center'>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        version="1.1"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        width="78"
                                        height="78"
                                        viewBox="0 0 682.667 682.667"
                                        xmlSpace="preserve"
                                    >
                                        <defs>
                                            <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                                <stop offset="0%" style={{ stopColor: "#F0675C", stopOpacity: 1 }} />
                                                <stop offset="100%" style={{ stopColor: "#F5A243", stopOpacity: 1 }} />
                                            </linearGradient>
                                        </defs>

                                        <g>
                                            <defs>
                                                <clipPath id="b" clipPathUnits="userSpaceOnUse">
                                                    <path
                                                        d="M0 512h512V0H0Z"
                                                        fill="#000000"
                                                        opacity="1"
                                                    ></path>
                                                </clipPath>
                                            </defs>
                                            <mask id="a">
                                                <rect width="100%" height="100%" fill="#ffffff" opacity="1"></rect>
                                            </mask>
                                            <g mask="url(#a)">
                                                <path
                                                    d="m0 0-134.174-134.174-63.873 63.872"
                                                    style={{
                                                        strokeWidth: 40,
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        strokeMiterlimit: 10,
                                                    }}
                                                    transform="matrix(1.33333 0 0 -1.33333 473.365 251.884)"
                                                    fill="none"
                                                    stroke="url(#gradient1)" // Apply gradient to stroke
                                                ></path>
                                                <g clipPath="url(#b)" transform="matrix(1.33333 0 0 -1.33333 0 682.667)">
                                                    <path
                                                        d="M0 0c0-130.339-105.661-236-236-236S-472-130.339-472 0s105.661 236 236 236S0 130.339 0 0Z"
                                                        style={{
                                                            strokeWidth: 40,
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeMiterlimit: 10,
                                                        }}
                                                        transform="translate(492 256)"
                                                        fill="none"
                                                        stroke="url(#gradient1)" // Apply gradient to stroke
                                                    ></path>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                                <p className='pw-texts text-center'>Password successfully reset! You can now log in with<br></br> your new password.</p>
                                <div className='form-login text-left'>

                                    <div className="btn-orange reset">
                                        <button className='reset-btn' onClick={handleSubmit}>Login</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default PasswordsuccessComp;
